<template>
    <div style="position:relative">
        <div class="form-header">
            <p>Even geduld aub</p>
        </div>
    </div>
</template>

<script>
import {get, call} from 'vuex-pathify'
import travel_step_mixin from "../../../travel_step_mixin";

export default {
    mixins:[travel_step_mixin],
    computed: {
        match_token: get('func_data/match_token')
    },
    mounted() {
        if (this.match_token) {
            location.href = '/thanks?match_token='+this.match_token;
        }
    }
}
</script>
